import { createTableColumn, TableColumnDefinition } from '@fluentui/react-components'
import { RestSchemas } from '@/contexts/QueryProvider'
import { ProjectCellContent } from './ProjectCellContent'
import { RowActionsMenu } from './RowActionsMenu'

type MessagesSubscriptionsOrganisationWorkspaceSummary =
  RestSchemas['Messages.Subscriptions.OrganisationWorkspaceSummary']

export const organisationWorkspacesTableColumns: TableColumnDefinition<MessagesSubscriptionsOrganisationWorkspaceSummary>[] =
  [
    createTableColumn<MessagesSubscriptionsOrganisationWorkspaceSummary>({
      columnId: 'projectName',
      compare: (a, b) => a.projectName.localeCompare(b.projectName),
      renderHeaderCell: () => 'Project',
      renderCell: (item) => <ProjectCellContent item={item} />,
    }),
    createTableColumn<MessagesSubscriptionsOrganisationWorkspaceSummary>({
      columnId: 'supportTeams',
      compare: (a, b) => a.supportTeams - b.supportTeams,
      renderHeaderCell: () => 'Support Teams',
      renderCell: (item) => (
        <>
          {item.supportTeams.toString()}
          <br />
          {item.supportTeamsSummary}
        </>
      ),
    }),
    createTableColumn<MessagesSubscriptionsOrganisationWorkspaceSummary>({
      columnId: 'projectTeams',
      compare: (a, b) => a.projectTeams - b.projectTeams,
      renderHeaderCell: () => 'Project Teams',
      renderCell: (item) => (
        <>
          {item.projectTeams.toString()}
          <br />
          {item.projectTeamsSummary}
        </>
      ),
    }),
    createTableColumn<MessagesSubscriptionsOrganisationWorkspaceSummary>({
      columnId: 'directLinks',
      compare: (a, b) => a.directLinks - b.directLinks,
      renderHeaderCell: () => 'Direct links',
      renderCell: (item) => item.directLinks.toString(),
    }),
    createTableColumn<MessagesSubscriptionsOrganisationWorkspaceSummary>({
      columnId: 'approver',
      renderHeaderCell: () => 'Approver',
      renderCell: (item) => {
        if (!item.audits.approver) return ''

        const [name, email] = item.audits.approver.split('\n')

        return (
          <>
            {name}
            <br />
            {email}
          </>
        )
      },
    }),
    createTableColumn<MessagesSubscriptionsOrganisationWorkspaceSummary>({
      columnId: 'approvalDate',
      compare: (a, b) =>
        a.audits.approvalDate && b.audits.approvalDate
          ? new Date(a.audits.approvalDate).getTime() - new Date(b.audits.approvalDate).getTime()
          : 0,
      renderHeaderCell: () => 'Approval Date',
      renderCell: (item) => {
        if (!item.audits.approvalDate) return '' // ✅ Show blank if no approval date

        // ✅ Format the date as "dd Month YYYY"
        const formattedDate = new Date(item.audits.approvalDate).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        })

        return formattedDate
      },
    }),
    // ✅ Added Actions column for Review Users Panel
    createTableColumn<MessagesSubscriptionsOrganisationWorkspaceSummary>({
      columnId: 'actions',
      renderHeaderCell: () => 'Actions',
      renderCell: (item) => <RowActionsMenu workspace={item} />,
    }),
  ]
